import { useRef } from 'react';

interface CategoriaCarouselProps {
  categorias: Array<{
    id: number;
    name: string;
    isActive?: boolean;
  }>;
  categoriaSeleccionada: number | null;
  onSeleccionar: (id: number | null) => void;
  label?: string;
}

const CategoriaCarousel = ({ 
  categorias, 
  categoriaSeleccionada, 
  onSeleccionar,
  label 
}: CategoriaCarouselProps) => {
  const scrollRef = useRef<HTMLDivElement>(null);

  const scrollLeft = () => {
    if (scrollRef.current) {
      scrollRef.current.scrollBy({ left: -200, behavior: 'smooth' });
    }
  };

  const scrollRight = () => {
    if (scrollRef.current) {
      scrollRef.current.scrollBy({ left: 200, behavior: 'smooth' });
    }
  };

  return (
    <div className="mb-4">
      {label && (
        <div className="mb-2 text-sm font-medium text-gray-700">{label}</div>
      )}
      <div className="relative">
        <button
          onClick={scrollLeft}
          className="absolute left-0 top-0 bottom-0 z-10 w-8 bg-gradient-to-r from-white to-transparent flex items-center justify-center hover:bg-gray-100 rounded-l"
          aria-label="Scroll left"
        >
          <svg className="w-5 h-5 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
          </svg>
        </button>
        
        <div
          ref={scrollRef}
          className="flex space-x-2 overflow-x-auto scrollbar-hide px-8"
          style={{ scrollbarWidth: 'none', msOverflowStyle: 'none' }}
        >
          {/* Botón "Todas" */}
          <button
            onClick={() => onSeleccionar(null)}
            className={`flex-shrink-0 px-4 py-2 rounded-lg font-medium transition whitespace-nowrap ${
              categoriaSeleccionada === null
                ? 'bg-primary-600 text-white shadow-md'
                : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
            }`}
          >
            Todas
          </button>
          
          {categorias.filter(cat => cat.isActive !== false).map((categoria) => (
            <button
              key={categoria.id}
              onClick={() => onSeleccionar(categoria.id)}
              className={`flex-shrink-0 px-4 py-2 rounded-lg font-medium transition whitespace-nowrap ${
                categoriaSeleccionada === categoria.id
                  ? 'bg-primary-600 text-white shadow-md'
                  : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
              }`}
            >
              {categoria.name}
            </button>
          ))}
        </div>

        <button
          onClick={scrollRight}
          className="absolute right-0 top-0 bottom-0 z-10 w-8 bg-gradient-to-l from-white to-transparent flex items-center justify-center hover:bg-gray-100 rounded-r"
          aria-label="Scroll right"
        >
          <svg className="w-5 h-5 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
          </svg>
        </button>
      </div>
    </div>
  );
};

export default CategoriaCarousel;

